module.exports = __webpack_public_path__ + "static/media/sms_enrollment_brand.ab14d8ae.png";